import { Avatar, IconButton, Menu, MenuItem } from "@mui/material";
import { menuThreeDotsDefaultIcon } from "assets/images";
import React from "react";

export interface ColumnActionProps {
	menuItems: string[];
	iconClass?: string;
	disabled?: boolean;
	handleMenuItemClick: (item: string) => void;
}

const ColumnAction: React.FC<ColumnActionProps> = ({
	menuItems,
	iconClass = "",
	disabled = false,
	handleMenuItemClick,
}) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const onMenuItemClick = (item: string) => {
		handleMenuItemClick(item);
		handleClose();
	};

	return (
		<>
			{menuItems.filter((m) => m !== "").length ? (
				<IconButton
					size="small"
					onClick={handleClick}
					className={iconClass}
					disabled={disabled}
				>
					<Avatar variant="square" src={menuThreeDotsDefaultIcon} alt="Menu" />
				</IconButton>
			) : (
				"-"
			)}
			{anchorEl && (
				<Menu
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={handleClose}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "right",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "right",
					}}
				>
					{menuItems
						.filter((m) => m !== "")
						.map((item: string) => {
							return (
								<MenuItem onClick={() => onMenuItemClick(item)} key={item}>
									{item}
								</MenuItem>
							);
						})}
				</Menu>
			)}
		</>
	);
};

export default ColumnAction;
